import {
  IconAuto,
  IconButton,
  IconCaretDown,
  IconCondo,
  IconEarthquake,
  IconHome,
  IconLandlord,
  IconMotorcycle,
  IconRV,
  IconRenters,
  IconUmbrella,
  IconWatercraft,
} from '@lmig/lmds-react-icons';
import { BillingInfo, ClaimInfo, PolicyInfo } from './Messages';
import SmartPopover from './SmartPopover';
import { Link } from '@lmig/lmds-react-link';
import { useState } from 'react';
import { useUserData } from 'Foundation/User/UserContext';
import { getCFBLink, getPLClaimsLink } from 'Foundation/Configurations/GlobalConfiguration';

type CustomerLinks = {
  policies?: PolicyInfo[];
  billing?: BillingInfo[];
  claims?: ClaimInfo[];
  customerId?: string;
};

export default function CustomerLinks({ policies, billing, claims, customerId }: CustomerLinks) {
  const [claimsIsClosed, setClaimsIsClosed] = useState<boolean>();
  const { userData } = useUserData();

  const getIcon = (lob: string) => {
    switch (lob) {
      case 'Auto':
        return (
          <span className="mywork-lob-icon">
            <IconAuto size="16" />
          </span>
        );
      case 'Home':
        return (
          <span className="mywork-lob-icon">
            <IconHome size="16" />
          </span>
        );
      case 'Condo':
        return (
          <span className="mywork-lob-icon">
            <IconCondo size="16" />
          </span>
        );
      case 'Renters':
        return (
          <span className="mywork-lob-icon">
            <IconRenters size="16" />
          </span>
        );
      case 'Motorcycle':
        return (
          <span className="mywork-lob-icon">
            <IconMotorcycle size="16" />
          </span>
        );
      case 'Earthquake':
        return (
          <span className="mywork-lob-icon">
            <IconEarthquake size="16" />
          </span>
        );
      case 'Landlord':
        return (
          <span className="mywork-lob-icon">
            <IconLandlord size="16" />
          </span>
        );
      case 'Umbrella':
        return (
          <span className="mywork-lob-icon">
            <IconUmbrella size="16" />
          </span>
        );
      case 'RV':
        return (
          <span className="mywork-lob-icon">
            <IconRV size="16" />
          </span>
        );
      case 'Watercraft':
        return (
          <span className="mywork-lob-icon">
            <IconWatercraft size="16" />
          </span>
        );
    }
  };

  return (
    <div className="mywork-customer-links">
      {policies && (
        <>
          <span className="mywork-tools-dropdown">Policies </span> (<span>{policies.length}</span>)
          <SmartPopover
            popoverId="mywork-policy-popover"
            trigger={
              <IconButton background="transparent" id="mywork-policy-links">
                <IconCaretDown color="teal" size="16" />
              </IconButton>
            }
            triggerId={'mywork-policy-links'}
          >
            <ul>
              {policies.map((policy) => (
                <li>
                  {getIcon(policy.lineOfBusiness)}
                  <Link href={policy.legacyUrl} target="_blank">
                    {policy.policyNumber}
                  </Link>
                </li>
              ))}
            </ul>
          </SmartPopover>
        </>
      )}
      {claims && (
        <>
          <span className="mywork-tools-dropdown">Claims </span> (<span>{claims.length}</span>)
          <SmartPopover
            popoverId="mywork-claims-popover"
            trigger={
              <IconButton background="transparent" id="mywork-claim-links">
                <IconCaretDown color="teal" size="16" />
              </IconButton>
            }
            triggerId={'mywork-claim-links'}
            closed={claimsIsClosed}
          >
            <ul>
              {claims.map((claim) => (
                <li>
                  {getIcon(claim.lineOfBusiness)}
                  <Link
                    onClick={() => {
                      window.open(
                        claim && claim.claimNumber.length == 12
                          ? getCFBLink(claim.claimNumber)
                          : getPLClaimsLink(userData?.isAgent() ?? true, claim.claimNumber, customerId),
                        '_blank',
                      );
                      setClaimsIsClosed((claimsIsClosed) => !claimsIsClosed);
                    }}
                  >
                    {claim.claimNumber}
                  </Link>
                </li>
              ))}
            </ul>
          </SmartPopover>
        </>
      )}
      {billing && (
        <>
          <span className="mywork-tools-dropdown">Billing </span> (<span>{billing.length}</span>)
          <SmartPopover
            popoverId="mywork-billing-popover"
            trigger={
              <IconButton background="transparent" id="mywork-billing-links">
                <IconCaretDown color="teal" size="16" />
              </IconButton>
            }
            triggerId={'mywork-billing-links'}
          >
            <ul>
              {billing.map((billing) => (
                <li>
                  {getIcon(billing.lineOfBusiness)}
                  <Link href={billing.legacyUrl} target="_blank">
                    {billing.billingId}
                  </Link>
                </li>
              ))}
            </ul>
          </SmartPopover>
        </>
      )}
    </div>
  );
}
